import xtend from 'xtend';
import _ from 'underscore';
import parallel from 'run-parallel';

import Sentry from '../../../utils/SentryReporter';
import Query from '../state/events-query';
import QueryStringIO from '../lib/query-string-io';
import EVS from '../EVENTS';
import Chat from './chat';
import Api from './api';
import WorkspaceActions from '../../../common/flux/WorkspaceActions'
import QueryString from '../../../utils/QueryString';


function parseEventID (id) {
    return _.last(id.split('_'));
}

function EventsSubscribe (bus, _api, store) {
    var api = Api(EVS.http, _api, bus);
    viewEffects({ bus, api, store, _api });
    Chat(bus, api, store);

    // websocket effects
    // fetch things again when you reconnect
    var ws = EVS.ws;
    // bus.on('*', (name) => console.warn('ev:', name))
    bus.on(ws._meta.reconnect, function (ev) {
        // don't use date filters if there is an eventID
        var params = Query.getParams(store.query.state());
        api.events.get(params);
        api.encoders.get({});
        api.categories.get({});
        api.keywords.get({});
        api.player.get({});
    });

    bus.on(ws._meta.open, function (ev) {
        if (store.socket.state().closed) {
            var params = Query.getParams(store.query.state());
            api.events.get(params);
            api.encoders.get({});
            api.categories.get({});
            api.keywords.get({});
            api.player.get({});
        }
    });

    update(bus, store);
}


// --------- effects -----------
function viewEffects ({ bus, api, store, _api }) {
    // bus.on('*', (...args) => {
    //     // send all actions to redux
    //     reduxStore.dispatch({type: 'BUS/' + args[0], payload: args[1]})
    // })
    // read/write to the URL
    bus.on(EVS.http.events.get.resolve, function (ev) {
        var req = xtend(ev.req);
        if (ev.req.getLive) req.liveOnly = true;
        // merge request params with querystring params
        req = {...QueryString.parse(location.search), ...req}
        QueryStringIO(req, Query.defaults);
    });
    bus.on('toggleActiveEvent', function (eventID) {
        var id = store.view.state().activeEvent;
        var q = Query.getParams(store.query.state());
        if (eventID != id) q.eventID = eventID;
        QueryStringIO(q, Query.defaults);
    });

    bus.on('get', function (data) {
        var params = Query.getParams(store.query.state());
        if (params.eventID) params = _.pick(params, ['eventID']);
        if (params.customID) params = _.pick(params, ['customID']);
        api.events.get(params);
        api.encoders.get({});
        api.categories.get({});
        api.keywords.get({});
        api.player.get({});
    });

    bus.on('pageChange', function (n) {
        api.events.get(Query.getParams.page(store.query.state(), n));
    });

    bus.on('resetFilters', function (params) {
        api.events.get(Query.getParams(Query.defaults));
    });

    bus.on('filterChange', function (params) {
        var req = Query.getParams(store.query.state(), params);
        api.events.get(req);
    });

    bus.on('quickFilter', function (params) {
        var req = Query.getParams(store.query.state(), params);
        api.events.get(req);
    });

    bus.on('editKeywords', function ({ eventID, keywords }) {
        // should send list of keyword IDs
        // need to first create keywords if they don't exist already

        var newKeywords = keywords.filter(keyword => !keyword.keywordID)

        parallel(newKeywords.map(function (keyword) {
            return function (cb) {
                _api.keywords.add({
                    keyword: keyword.keyword
                }, cb)
            }
        }), function doneMakingKeywords (err, res) {
            if (err) {
                // should show an error message on the event store
                // return console.log('err', err)
                return
            }

            var newKeywordIds = res.map(function (_res) {
                return _res.data.keywordID
            })

            var existingKeywordIds = keywords
                .filter(k => k.keywordID)
                .map(k => k.keywordID)

            api.events.edit({
                eventID,
                keywords: existingKeywordIds.concat(newKeywordIds)
            })
        });
    });

    bus.on('search', function (ev) {
        var req = Query.getParams.search(store.query.state(), ev);
        api.events.get(req);
    });

    bus.on('shiftMessage', function (ev) {
        store.messages.shift();
    });

    bus.on('shiftError', function (ev) {
        var pair = _.find(_(store.requests.state()).map(function (domain, k) {
            return [k, domain.errors];
        }), function (pair) {
            return pair[1][ev.cid];
        });

        if (pair) store.requests[pair[0]].clearError(ev.cid);
    });

    // events
    bus
        .on('events.edit', function (params) {
            api.events.edit(params || {});
        })
        .on('events.delete', function (params) {
            api.events.delete(params || {});
        })
        .on('events.start', function (params) {
            api.events.start(params || {});
        })
        .on('events.stop', function (params) {
            api.events.stop(params || {});
        })
        .on('events.miscAssetToEvent', function (ev) {
            api.assets.miscAssetToEvent(ev);
        })
        .on('events.publish', function (params) {
            api.events.publish(params);
        })
        .on('events.unpublish', function (params) {
            api.events.unpublish(params);
        })
        .on('events.add', function (params, b) {
            api.events.add(params);
        });


    // assets
    bus
        .on('assets.get', function (ev) {
            // if (store.miscAssets.state().hasFetched) return;
            // api.assets.get(ev);
        })
        .on('assets.add', function (ev) {
            // @TODO
            // do we use this?
        })
        .on('assets.assignThumbnail', function (ev) {
            api.thumbs.replace(ev);
        })
        .on('assets.delete', function (ev) {
            api.assets.delete(ev);
        })
        .on('assets.edit', function (ev) {
            api.assets.edit(ev);
        })
        .on('assets.editLink', function (ev) {
            api.assets.editLink(ev)
        })
        .on('assets.miscAssetToEvent', function (ev) {
            api.assets.miscAssetToEvent(ev);
        })
        .on('assets.getMiscAssets', function (ev) {
            api.assets.getMiscAssets(ev);
        });

    // analytics
    // bus
    //     .on('metadata.analytics.get', function (ev) {
    //         api.analytics.get(ev);
    //     })
    //     .on('metadata.analytics.getMostWatched', function (ev) {
    //         api.analytics.getMostWatched(ev);
    //     })
    //     .on('metadata.analytics.getUpcomingEvents', function (ev) {
    //         api.analytics.getUpcomingEvents(ev);
    //     });

    // Transcripts
    bus
        .on('transcript.create', function (ev) {
            api.transcript.create(ev);
        })
        .on('transcript.getTranscriptInfo', function (ev) {
            api.transcript.getTranscriptInfo(ev);
        })
        .on('transcript.setUseAsCaptions', ev => {
            api.transcript.setUseAsCaptions(ev);
        })
        .on('transcript.resubmit', function (ev) {
            api.transcript.resubmit(ev);
        })
        .on('transcript.delete', function (ev) {
            api.transcript.delete(ev);
        })

    // Domain Restrictions
    bus
        .on('restrictedDomains.add', function (ev) {
            api.restrictedDomains.add(ev)
        })
        .on('restrictedDomains.delete', function (ev) {
            api.restrictedDomains.delete(ev)
        })

    // Audio Description
    bus
        .on('audioDescription.getProject', function (ev) {
            api.audioDescription.getProject(ev);
        })

    bus
        .on('streamTargets.getAltProviders', function (payload) {
            api.streamTargets.getAltProviders(payload || {});
        })
        .on('streamTargets.getAltDestinations', function (payload) {
            if (payload.hasOwnProperty('eventID')) {
                api.streamTargets.getAltDestinations(payload);
            }
        })
        .on('streamTargets.add', function (payload) {
            store.streamTargetView.addPending(false)
            api.streamTargets.add(payload)
        })
        .on('streamTargets.edit', function (payload) {
            api.streamTargets.edit(payload)
        })
        .on('streamTargets.delete', function (payload) {
            if (
                payload.hasOwnProperty('eventID') &&
                payload.hasOwnProperty('altEventStreamID')
            ) {
                api.streamTargets.delete(payload)
            }
        })
        .on('streamTargets.addPending', function (data) {
            // Component State for Pending target
            store.streamTargetView.addPending(data)
        })

    // player
    bus.on('player.setPreferenceAsDefault', function (ev) {
        // @XXX it seems like it is not possible send this event from the UI
        // in this route
    });

    ['metamarkers', 'facebookLive', 'player'].forEach(function (domain) {
        metadataEffects({
            get: domain + '.' + 'get',
            edit: domain + '.' + 'edit',
            add: domain + '.' + 'add',
            delete: domain + '.' + 'delete'
        }, bus, api[domain], store[domain]);
    });

    ['locations', 'technicians', 'categories', 'keywords']
        .forEach(function (domain) {
            metadataEffects({
                get: 'metadata.' + domain + '.' + 'get',
                edit: 'metadata.' + domain + '.' + 'edit',
                add: 'metadata.' + domain + '.' + 'add',
                delete: 'metadata.' + domain + '.' + 'delete'
            }, bus, api[domain], store[domain]);
        });
}


// handle crud events
// listen for view events, make api calls, and emit http events
function metadataEffects (evs, bus, apiFns, store) {
    bus.on(evs.get, function (ev) {
        if (store.state().hasFetched) return;
        apiFns.get(ev || {});
    });

    ['edit', 'add', 'delete'].forEach(function (action) {
        bus.on(evs[action], function (data) {
            apiFns[action](data);
        });
    });
}


// ---------- update -----------

function update (bus, store) {
    // view
    bus
        .on('shiftError', function (ev) {
            // @TODO
        })
        .on('toggleActiveEvent', function (eventID) {
            store.view.setActiveEvent(eventID);
        })
    ;

    // transcript
    bus
        .on('transcript.toggleModal', ev => {
            store.transcriptView.set(ev);
        })
    ;

    update.websocket(EVS.ws, bus, store);
    update.http(EVS.http, bus, store);
}

update.websocket = function (evs, bus, store) {
    // bus.on('*', function (ev) {
    //     console.log("update ws: ev,store:", ev, store)
    // });
    bus.on(evs._meta.open, function (ev) {
        store.socket.open();
    });

    bus.on(evs._meta.close, function (ev) {
        store.socket.close();
    });

    bus.on(evs._meta.trouble, function (ev) {
        store.socket.trouble();
    });

    bus.on(evs._meta.reconnect, function (ev) {
        store.socket.reconnect();
    });

    bus.on(evs._meta.error, function (err) {
        store.socket.error(err);
    });

    var MetadataSub = _.partial(WebsocketSubscription, {}, {
        add: function (msg, store) {
            if (!store.state().hasFetched) return;
            store.add(msg.data);
        }
    });

    // events + metadata
    // this is kind of bad, but we need to do this here because
    // we need to grab the previous value before it is updated below
    bus.on(evs.categories.update, function (msg) {
        if (!store.categories.state().hasFetched) return;
        store.events.updateCategory(
            store.categories.state().data[msg.data.categoryID],
            msg.data);
    });

    bus.on(evs.keywords.update, function (msg) {
        if (!store.keywords.state().hasFetched) return;
        store.events.updateKeyword(
            store.keywords.state().data[msg.data.keywordID],
            msg.data);
    });


    // -------- encoder connect/disconnect -----------

    bus.on(evs.encoder.connect, function (msg) {
        store.events.encoderConnect(msg.data);
        store.encoders.edit(msg.data);
    });

    bus.on(evs.encoder.disconnected, function (msg) {
        store.events.encoderDisconnect(msg.data);
        store.encoders.edit(msg.data);
    });

    // ----------------------------------------------


    update.websocket.events(evs.events, bus, store);
    update.websocket.assets(evs.asset, bus, store);
    update.websocket.transcode(evs.transcode, bus, store);

    MetadataSub(evs.encoder, bus, store.encoders);
    MetadataSub(evs.keywords, bus, store.keywords);
    MetadataSub(evs.categories, bus, store.categories);
    MetadataSub(evs.location, bus, store.locations);
    MetadataSub(evs.techs, bus, store.technicians);

    // uri restrictions
    bus.on(evs.eventdomrestrictions.upsert, function (ev) {
        store.events.edit(ev.data)
    })
    bus.on(evs.eventdomrestrictions.delete, function (ev) {
        if (ev.data.eventID) {
            ev.data.eventID = ev.data.eventID.slice(ev.data.eventID.indexOf('_') + 1)
            ev.data.restrictedDomains = []
            store.events.edit(ev.data)
        }
    })

    // thumbs
    bus.on(evs.thumbs.add, function (ev) {
        // msg.data example:
        // [ { "assetID": "fcfdb014ba05513334485d34b1a9dc9aec926b26", "clientID": "1000000000", "eventID": "2018011001", "name": "live recording 2018-01-25-19.46.18.625-UTC", "type": "video", "dateCreated": "2018-01-25 11:47:06", "fileSize": "5148124", "totalRunTime": "00:00:36", "totalRunTimeS": 36, "currentStatus": "available", "fileUrl": "https://invintus-mediaworkflow.s3.amazonaws.com/1000000000/fcfdb014ba05513334485d34b1a9dc9aec926b26.mp4", "thumbnail": "https://invintus-client-images.s3.amazonaws.com/1000000000/fcfdb014ba05513334485d34b1a9dc9aec926b26.jpg", "sprite": null, "liveID": "6b31f7a26071da591721be100863a513", "recStartDate": "2018-01-25 19:46:17", "recStopDate": "2018-01-25 19:46:56", "estRecDur": "00:00:39", "path": "https://invintus-mediaworkflow.s3.amazonaws.com/1000000000/fcfdb014ba05513334485d34b1a9dc9aec926b26.mp4", "TTL": "2018-02-04 11:47:06", "advancedDetails": { "general": { "filename": "fcfdb014ba05513334485d34b1a9dc9aec926b26.mp4", "format": "mpeg-4", "filesize": 5167830, "durationHMS": "00:00:36", "durationS": 36, "bitrate": 1145 }, "video": [ { "format": "avc", "bitrate": 1022, "dimensions": { "width": "1280", "height": "720" }, "aspect_ratio": "16:9", "framerate_mode": "Variable", "frame_rate": "29.970 fps", "stream_size": 4613777, "language": "en" } ], "audio": [ { "format": "aac", "title": "AAC", "format_profile": "LC", "bitrate": 113, "channels": "2.0ch", "stream_size": 509616, "language": "en" } ], "image": null, "text": null }, "previewURI": { "main": "//invintus-otfp.global.ssl.fastly.net/1000000000/fcfdb014ba05513334485d34b1a9dc9aec926b26.m3u8", "backup": "https://invintus-mediaworkflow.s3.amazonaws.com/1000000000/fcfdb014ba05513334485d34b1a9dc9aec926b26.mp4" } } ]
        store.events.updateAsset(ev.data[0]);
    });

    bus.on(evs.thumbs.update, function (ev) {
        // [ { "assetID": "2ed013bd00bcf39cc24beada2df50825a5a29c6a", "clientID": "1000000000", "eventID": "2018011001", "name": "Edit: 2018-01-16 22:33:43 ", "type": "video", "dateCreated": "2018-01-16 22:33:43", "fileSize": "62968033", "totalRunTime": "00:07:15", "totalRunTimeS": 435, "currentStatus": "available", "fileUrl": "https://invintus-mediaworkflow.s3.amazonaws.com/1000000000/2ed013bd00bcf39cc24beada2df50825a5a29c6a.mp4", "thumbnail": "https://invintus-client-images.s3.amazonaws.com/1000000000/2ed013bd00bcf39cc24beada2df50825a5a29c6a.png", "sprite": null, "liveID": null, "recStartDate": null, "recStopDate": null, "estRecDur": null, "path": "https://invintus-mediaworkflow.s3.amazonaws.com/1000000000/2ed013bd00bcf39cc24beada2df50825a5a29c6a.mp4", "TTL": "2018-01-26 22:33:43", "advancedDetails": { "general": { "filename": "2ed013bd00bcf39cc24beada2df50825a5a29c6a.mp4", "format": "mpeg-4", "filesize": 62968033, "durationHMS": "00:07:15", "durationS": 435, "bitrate": 1158 }, "video": [ { "format": "avc", "bitrate": 1039, "dimensions": { "width": "1280", "height": "720" }, "aspect_ratio": "16:9", "framerate_mode": "Variable", "frame_rate": "29.970 fps", "stream_size": 56515356, "language": "en" } ], "audio": [ { "format": "aac", "title": "AAC", "format_profile": "LC", "bitrate": 110, "channels": "2.0ch", "stream_size": 6004872, "language": "en" } ], "image": null, "text": null }, "previewURI": { "main": "//invintus-otfp.global.ssl.fastly.net/1000000000/2ed013bd00bcf39cc24beada2df50825a5a29c6a.m3u8", "backup": "https://invintus-mediaworkflow.s3.amazonaws.com/1000000000/2ed013bd00bcf39cc24beada2df50825a5a29c6a.mp4" } }]
        store.events.updateAsset(ev.data[0]);
    });

    // Events Publish
    bus.on(evs.events.publish, function (ev) {
        store.events.edit(ev.data);
    });

    bus.on(evs.events.unpublish, function (ev) {
        store.events.edit(ev.data);
    });

    // Complete Publish
    bus.on(evs.publish.publish, function (ev) {
        store.events.edit(ev.data);
    });

    bus.on(evs.publish.unpublish, function (ev) {
        store.events.edit(ev.data);
    });

    // Facebook Live
    bus.on(evs.facebooklive.add, function (ev) {
        store.events.updateFacebookLive('add', 'add', ev.data);
    });
    bus.on(evs.facebooklive.delete, function (ev) {
        store.events.updateFacebookLive('add', 'delete', ev.data);
    });


    // Transcripts
    bus
        .on(evs.transcripts.completed, function (ev) {
            var storeData;

            try {
                storeDate = store.transcript.state.data
            } catch (error) {
                return
            }

            if (
                parseEventID(storeData.eventID) !==
                parseEventID(ev.data.eventID)
            ) return;

            // @XXX this is bad becuase the other snacks are elsewhere
            // in this file. but, we need this conditional logic above
            store.messages.push({
                type: 'success',
                message: 'Transcription complete'
            });

            store.transcript.update(ev.data);
        })
    ;

    // Metamarkers
    bus
        .on(evs.metamarkers.update, function (ev) {
            var evID = parseEventID(ev.data[0].eventID);
            if (!store.events.state().data[evID]) return;

            store.events.edit({
                eventID: evID,
                eventMetaMarkers: ev.data
            });
        })

        .on(evs.metamarkers.add, function (ev) {
            var evID = parseEventID(ev.data[0].eventID);
            if (!store.events.state().data[evID]) return;

            store.events.edit({
                eventID: evID,
                eventMetaMarkers: ev.data
            });
        })

        .on(evs.metamarkers.delete, function (ev) {
            var evID = parseEventID(ev.data.eventID);
            if (!store.events.state().data[evID]) return;
            store.events.edit({
                eventID: evID,
                eventMetaMarkers: store.events.state().data[evID]
                    .eventMetaMarkers.filter(function (m) {
                        return m.markerID != ev.data.markerID;
                    })

            });
        });

    function handleAltDestMsg (method, ev) {
        if (ev.data !== null && _.isArray(ev.data) && ev.data.length >= 1) {
            // The targets in the array will all share the
            // same Event ID so we only need the first
            var evID = parseEventID(ev.data[0].eventID);
            if (!store.events.state().data[evID]) return;
            store.eventTargetDestinations[method](evID, ev.data)
        }
    }

    bus
        .on(evs.eventaltdest.add, ev => {
            handleAltDestMsg('addTarget', ev);
        })
        .on(evs.eventaltdest.update, ev => {
            handleAltDestMsg('editTarget', ev);
        })
        .on(evs.eventaltdest.delete, ev => {
            var evID = parseEventID(ev.data.eventID);
            if (!store.events.state().data[evID]) return;
            store.eventTargetDestinations.deleteTarget(ev.data)
        })
        .on(evs.Eventaltdest.start, ev => {
            handleAltDestMsg('start', ev);
        })
        .on(evs.Eventaltdest.stop, ev => {
            handleAltDestMsg('stop', ev);
        })
};

function WebsocketSubscription (_map, parsers, evs, bus, store) {
    var map = xtend({
        update: 'edit'
    }, _map);

    Object.keys(evs).forEach(function (k) {
        bus.on(evs[k], function (msg) {
            if (parsers[k]) return parsers[k](msg, store);
            var fn = store[map[k] || k];
            if (fn) fn.call(store, msg.data);
        });
    });
}

update.websocket.events = function (evs, bus, store) {
    bus.on(evs.add, function (ev) {
        // only add if it is in the current query and page size
        var q = store.query.state();
        var inQuery = Query.isWithinQuery(q, ev.data);
        var inPage = store.events.isWithinPage(
            q.resultMax,
            q.sortBy === 'ASC',
            ev.data
        );

        if (!(inQuery && inPage)) return;

        store.events.add(ev.data);
    });

    bus.on(evs.delete, function (ev) {
        store.events.delete(ev.data);
    });

    bus.on(evs.update, function (ev) {
        store.events.edit(ev.data);
    });

    var eventMsgTypes = [evs.start, evs.stopping, evs.stop, evs.disconnected];
    eventMsgTypes.forEach(function (ev) {
        bus.on(ev, (msg) => store.events.edit(msg.data));
    });
};


update.websocket.assets = function (evs, bus, store) {
    bus.on(evs.add, function (ev) {
        if (!ev.data) return Sentry.send('Invalid ws message', 'error', ev);
        store.events.addAsset(ev.data);
    });

    bus.on(evs.update, function (ev) {
        store.events.updateAsset(ev.data);
    });

    bus.on(evs.delete, function (ev) {
        store.events.deleteAsset(ev.data);
    });
};


update.websocket.transcode = function (evs, bus, store) {
    bus.on(evs.start, function (msg) {
        store.events.updateAsset(msg.data);
    });

    bus.on(evs.processing, function (msg) {
        if (!store.events.state().data[msg.data.eventID]) return;

        var oldAsset = _(store.events.state().data[msg.data.eventID]
            .mediaAssets).findWhere({ assetID: msg.data.assetID });
        if (!oldAsset) return;

        store.events.updateAsset(xtend(oldAsset, {
            transcodeProgress: xtend(oldAsset.transcodeProgress || {}, {
                progress: msg.data.progress
            })
        }));
    });

    bus.on(evs.complete, function (msg) {
        // update the asset status
        store.events.updateAsset(xtend(msg.data, {
            currentStatus: 'available'
        }));
    });
};
update.http = function (evs, bus, store) {
    // bus.on('*', function (a,b,c) {
    //     console.log(a,b,c)
    // })

    // set the query state after a 'get' resolves
    bus.on(evs.events.get.resolve, function (ev) {
        store.query.setFromRequest({
            body: ev.req,
            currentPage: ev.res.meta.currentPage,
            totalPages: ev.res.meta.totalPages
        });
    });

    bus.on(evs.events.publish.resolve, function (ev) {
        store.events.edit(ev.res.data);
    });
    bus.on(evs.events.unpublish.resolve, function (ev) {
        store.events.edit(ev.res.data);
    });
    bus.on(evs.events.start.error, function (ev) {
        store.requests.events.error(ev);
    });
    bus.on(evs.events.add.resolve, function (resp) {
        // @FIXME: this should be changed for multiple creates
        WorkspaceActions.toggleCreatedEventModal(resp)
    });

    // events publishing requests
    requestUpdate(evs.events.publish, bus, store.requests.events);
    requestUpdate(evs.events.unpublish, bus, store.requests.events);

    // set data
    HttpStateSubscription(evs.events, store.events, bus, {
        // add: function (a,b) {
        //     console.log('HttpState->add', a,b)
        // },
        delete: function (ev) {
            store.events.delete(xtend(ev.res.data, {
                eventID: parseEventID(ev.res.data.eventID)
            }));
        }
    });


    // what do we use the metamarker store for?
    // HttpStateSubscription(evs.metamarkers, store.metamarkers, bus, {
    //     add: ev => store.metamarkers.get(ev.res.data)
    // });

    HttpStateSubscription(evs.encoders, store.encoders, bus);
    HttpStateSubscription(evs.categories, store.categories, bus);
    HttpStateSubscription(evs.keywords, store.keywords, bus, {
        get: (ev) => store.keywords.get(ev.res.data.clientKeywords),
    });
    HttpStateSubscription(evs.player, store.playerPrefs, bus);

    // HttpStateSubscription(evs.assets, store.miscAssets, bus);
    // this is `Assets/getMediaAssets`
    bus.on(evs.assets.get.resolve, function (ev) {
        if (!ev.res.data) return;
        store.events.setAssets(ev.req.eventID, ev.res.data);
    });

    // assets http updates
    bus
        .on(evs.assets.getMiscAssets.resolve, function (ev) {
            store.miscAssets.get(ev.res.data);
        });

    // @TODO miscAssetToEvent
    // bus.on(miscAssetToEvent)

    HttpStateSubscription(evs.locations, store.locations, bus, {
        get: ev => store.locations.get(ev.res.data.clientLocations)
    });
    HttpStateSubscription(evs.technicians, store.technicians, bus, {
        get: ev => store.technicians.get(ev.res.data.clientTechs)
    });

    // analytics state update
    bus.on(evs.analytics.get.resolve, function (ev) {
        store.analytics.get(ev.res.data);
    });
    bus.on(evs.analytics.getMostWatched.resolve, function (ev) {
        store.analytics.getMostWatched(ev.res.data);
    });
    bus.on(evs.analytics.getUpcomingEvents.resolve, function (ev) {
        store.analytics.getUpcomingEvents(ev.res.data);
    });

    // facebook
    // update the event object
    bus
        .on(evs.facebookLive.add.resolve, ev => {
            var shortEvID = parseEventID(ev.res.data.eventID);
            store.events.updateFacebookLive('add', xtend(ev.res.data, {
                eventID: shortEvID
            }));
        })
        .on(evs.facebookLive.delete.resolve, ev => {
            store.events.deleteFacebookLive({
                eventID: parseEventID(ev.res.data.eventID)
            });
        });


    // metamarkers
    bus
        .on(evs.metamarkers.add.resolve, function (ev) {
            // add it to the event's data
            // we get back an array of all of them
            store.events.edit({
                eventID: parseEventID(ev.res.data[0].eventID),
                eventMetaMarkers: ev.res.data
            });
        })

        .on(evs.metamarkers.delete.resolve, function (ev) {
            // ev.res.data -- { eventID, markerID }
            var evID = parseEventID(ev.res.data.eventID);
            store.events.edit({
                eventID: evID,
                eventMetaMarkers: store.events.state().data[evID]
                    .eventMetaMarkers.filter(function (m) {
                        return m.markerID != ev.res.data.markerID;
                    })

            });
        })

        .on(evs.metamarkers.edit.resolve, function (ev) {
            var evID = parseEventID(ev.res.data[0].eventID);
            if (!store.events.state().data[evID]) return;

            store.events.edit({
                eventID: evID,
                eventMetaMarkers: ev.res.data
            });
        });

    // request state for metadata domains
    ['events', 'encoders', 'categories', 'keywords', 'player', 'locations',
        'technicians', 'facebookLive']
        .forEach(function (domain) {
            requestUpdate(evs[domain].get, bus, store.requests[domain]);
            requestUpdate(evs[domain].edit, bus, store.requests[domain]);
            requestUpdate(evs[domain].add, bus, store.requests[domain]);
            requestUpdate(evs[domain].delete, bus, store.requests[domain]);
        })
    ;

    // metamarkers requests
    requestUpdate(evs.metamarkers.add, bus, store.requests.metamarkers);
    requestUpdate(evs.metamarkers.edit, bus, store.requests.metamarkers);
    requestUpdate(evs.metamarkers.delete, bus, store.requests.metamarkers);


    // --------------- snack messages ------------------

    // events snacks
    bus
        .on(evs.events.edit.resolve, function (ev) {
            store.messages.push({
                type: 'success',
                message: 'Event updated'
            });

        })

        .on(evs.events.delete.resolve, function (ev) {
            store.messages.push({
                type: 'success',
                message: 'Event deleted'
            });
        });

    // metamarkers snacks
    bus
        .on(evs.metamarkers.edit.resolve, function (ev) {
            store.messages.push({
                type: 'success',
                message: 'Agenda updated'
            });
        })

        .on(evs.metamarkers.add.resolve, function (ev) {
            store.messages.push({
                type: 'success',
                message: 'Agenda item created'
            });
        })

        .on(evs.metamarkers.delete.resolve, function (ev) {
            store.messages.push({
                type: 'success',
                message: 'Agenda item deleted'
            });
        });

    // transcript snacks
    bus
        .on(evs.transcript.setUseAsCaptions.resolve, function (ev) {
            store.messages.push({
                type: 'success',
                message: 'Event updated'
            });
        })

        .on(evs.transcript.setUseAsCaptions.error, function (ev) {
            // @TODO
            // console.log('caption error', ev);
        })

        .on(evs.transcript.resubmit.resolve, function (ev) {
            store.messages.push({
                type: 'success',
                message: 'Event submitted for re-transcription'
            });
        })

        // delete
        .on(evs.transcript.delete.resolve, function (ev) {
            store.messages.push({
                type: 'success',
                message: 'Transcript deleted'
            });
        })

        .on(evs.transcript.delete.error, function (ev) {
            store.messages.push({
                type: 'error',
                message: 'Error deleting transcript'
            });
        })

        .on(evs.transcript.create.resolve, function (ev) {
            store.messages.push({
                type: 'success',
                message: 'Transcript started'
            });
        })
    ;

    // Restricted Domains Snacks
    bus
        .on(evs.restrictedDomains.add.resolve, function (ev) {
            store.messages.push({
                type: 'success',
                message: 'Updated'
            });
        })
        .on(evs.restrictedDomains.add.error, function (ev) {
            store.messages.push({
                type: 'error',
                message: ev
            });
        })
        .on(evs.restrictedDomains.delete.resolve, function (ev) {
            store.messages.push({
                type: 'success',
                message: 'Updated'
            });
        })
    ;

    // Asset Thumb replace snack
    bus
        .on(evs.thumbs.replace.resolve, function (ev) {
            store.messages.push({
                type: 'success',
                message: 'Thumbnail Created'
            });
        })

    // -------------------------------------------------

    // event Assets/getMediaAssets
    // requestUpdate(evs.assets.get, bus, store.requests.miscAssets);


    // analytics requests
    requestUpdate(evs.analytics.get, bus, store.requests.analytics);
    requestUpdate(evs.analytics.getMostWatched, bus,
        store.requests.analytics);
    requestUpdate(evs.analytics.getUpcomingEvents, bus,
        store.requests.analytics);



    // --------------- Transcript updates ----------------------

    bus
        .on(evs.transcript.getTranscriptInfo.resolve, function (ev) {
            store.transcript.getTranscriptInfo(ev.res.data);
        })

        .on(evs.transcript.setUseAsCaptions.resolve, function (ev) {
            store.transcript.update(ev.res.data);
        })

        .on(evs.transcript.resubmit.resolve, function (ev) {
            store.transcript.update(ev.res.data);
            store.transcriptView.set({
                editModal: false
            });
        })

        .on(evs.transcript.create.resolve, function (ev) {
            store.transcript.getTranscriptInfo(ev.res.data);
            store.transcriptView.set({
                createModal: false
            });
        })

        .on(evs.transcript.delete.resolve, function (ev) {
            store.transcript.clear();
            store.transcriptView.set({
                editModal: false,
                deleteModal: false
            });
        })
    ;

    requestUpdate(evs.transcript.getTranscriptInfo, bus,
        store.requests.transcript);

    requestUpdate(evs.transcript.setUseAsCaptions, bus,
        store.requests.transcript);

    requestUpdate(evs.transcript.resubmit, bus, store.requests.transcript);
    requestUpdate(evs.transcript.delete, bus, store.requests.transcript);
    requestUpdate(evs.transcript.create, bus, store.requests.transcript);

    // -----------------------------------------------------------


    // Stream Targets
    bus
        .on(evs.streamTargets.getAltProviders.resolve, function (ev) {
            store.streamTargets.set(ev.res.data)
        })
        .on(evs.streamTargets.getAltDestinations.resolve, function (ev) {
            store.eventTargetDestinations.set(ev.req.eventID, ev.res.data)
        })
        .on(evs.streamTargets.add.resolve, function (ev) {
            store.eventTargetDestinations.addTarget(ev.res.data)
        })
        .on(evs.streamTargets.edit.resolve, function (ev) {
            store.eventTargetDestinations.editTarget(ev.res.data)
        })
        .on(evs.streamTargets.delete.resolve, function (ev) {
            store.eventTargetDestinations.deleteTarget(ev.res.data)
        })

    requestUpdate(evs.streamTargets.getAltProviders, bus, store.requests.streamTargets)
    requestUpdate(evs.streamTargets.getAltDestinations, bus, store.requests.eventTargetDestinations)
    requestUpdate(evs.streamTargets.add, bus, store.requests.eventTargetDestinations)
    requestUpdate(evs.streamTargets.edit, bus, store.requests.eventTargetDestinations)
    requestUpdate(evs.streamTargets.delete, bus, store.requests.eventTargetDestinations)
};

EventsSubscribe.viewEffects = viewEffects;
EventsSubscribe.update = update;
export default EventsSubscribe;


// -----------------------

function applyEvents (evs, fns, bus) {
    Object.keys(evs).forEach(function (k) {
        bus.on(evs[k], fns[k]);
    });
}

applyEvents.store = function (evs, store, bus) {
    Object.keys(evs).forEach(function (k) {
        bus.on(evs[k], function () {
            if (typeof store[k] === 'function') {
                store[k].apply(store, arguments);
            }
        });
    });
};

function HttpStateSubscription (evs, store, bus, fns) {
    fns = fns || {};
    applyEvents({
        get: evs.get.resolve,
        edit: evs.edit.resolve,
        add: evs.add.resolve,
        delete: evs.delete.resolve
    }, xtend({
        get: ev => store.get(_parse(ev)),
        edit: ev => store.edit(_parse(ev)),
        add: ev => store.add(_parse(ev)),
        delete: ev => store.delete(_parse(ev))
    }, fns), bus);
}

function _parse (ev) {
    return ev.res.data;
}

function requestUpdate (evs, bus, store) {
    bus
        .on(evs.start, req => store.start(req))
        .on(evs.resolve, req => store.resolve(req))
        .on(evs.error, data => store.error(data));
}